import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useFollow(xUserId: string) {
  const { user } = useAuth();
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState(false);

  useEffect(() => {
    if (!user) {
      setIsFollowing(false);
      setLoading(false);
      return;
    }

    const check = async () => {
      const { data } = await supabase
        .from("follows")
        .select("id")
        .eq("user_id", user.id)
        .eq("x_user_id", xUserId)
        .maybeSingle();

      setIsFollowing(!!data);
      setLoading(false);
    };

    check();
  }, [user, xUserId]);

  const toggle = useCallback(async () => {
    if (!user || toggling) return;
    setToggling(true);

    if (isFollowing) {
      await supabase
        .from("follows")
        .delete()
        .eq("user_id", user.id)
        .eq("x_user_id", xUserId);
      setIsFollowing(false);
    } else {
      await supabase
        .from("follows")
        .insert({ user_id: user.id, x_user_id: xUserId });
      setIsFollowing(true);
    }

    setToggling(false);
  }, [user, xUserId, isFollowing, toggling]);

  return { isFollowing, loading, toggling, toggle };
}
